import { InputAdornment } from "@mui/material";
import clsx from "clsx";
import { forwardRef } from "react";
import { CustomTextField, classes } from "./styles";

const TextInput = forwardRef(function TextInput(
  {
    id,
    buttonEnd,
    label,
    value,
    required,
    style,
    error,
    helperText,
    onClick,
    onChange,
    col,
    icon,
    inputedit,
    InputProps,
    disabled,
    iconposition,
    size,
    hideArrows,
    startAdornment,
    endAdornment,
    ...rest
  },
  ref
) {
  const inputProps = {
    id: id,
    value: value,
    required: required,
    disabled: disabled,
    onClick: onClick,
    onChange: onChange,
    inputedit: inputedit,
    col: col,
    ...style,
  };

  return (
    <>
      <CustomTextField
        ref={ref}
        label={label}
        variant="outlined"
        size={size || "small"}
        className={clsx({
          [classes.hideArrows]: hideArrows,
        })}
        InputProps={{
          ...InputProps,
          startAdornment: startAdornment ? (
            startAdornment
          ) : icon && iconposition !== "end" ? (
            <InputAdornment position="start">{icon}</InputAdornment>
          ) : undefined,
          endAdornment: endAdornment ? (
            endAdornment
          ) : icon && iconposition === "end" ? (
            <InputAdornment position="end">{icon}</InputAdornment>
          ) : buttonEnd ? (
            <InputAdornment position="end" sx={{ position: "absolute", right: "6px" }}>
              {buttonEnd}
            </InputAdornment>
          ) : undefined,
        }}
        error={error}
        helperText={helperText}
        {...inputProps}
        {...rest}
      />
    </>
  );
});

export default TextInput;
